import { ProductCardType } from '@/constants'
import { labelPositionProductCard } from '@/constants/positions'
import { useNotification } from '@/containers'
import type { Product } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { useMemo } from 'react'
import { CompareIcon } from '../Icon/CompareIcon'
import ImageOptimize from '../ImageOptimize'
import OriginPrice from '../Price/OriginPrice'
import SalePrice from '../Price/SalePrice'

export interface ProductProps {
  product: Product
  type?: string
  layout?: number
  className?: string
  descClassName?: string
  imageClassName?: string
  canCompare?: boolean
  handleAddToCompare?: () => void
}

const ProductCompareCard = ({
  className,
  product,
  type,
  layout,
  imageClassName = '',
  canCompare = false,
  handleAddToCompare,
}: ProductProps) => {
  const productName = useMemo(() => {
    return getTranslate(product?.name)
  }, [product])
  const { systemConfig } = useNotification()
  const percent = Math.ceil(100 - (product.finalPrice / product.price) * 100)

  return (
    <div
      className={`itemProducts items-center overflow-hidden ${
        className ? className : ''
      } ${type ? type : ''} ${layout ? 'l' + layout : ''}`}
    >
      <div
        className={`image-thumb relative block w-full overflow-hidden rounded-t-sm`}
      >
        <div
          className={`relative block w-full overflow-hidden pt-[80%] focus:border-0 focus:outline-0`}
        >
          <ImageOptimize
            className={`productImage absolute left-0 top-0 aspect-square h-full w-full object-cover px-[15px] ${imageClassName} ${
              type == ProductCardType.TRENDING && 'rounded-sm !p-0'
            } `}
            src={
              product.thumbnail
                ? product?.thumbnail
                : systemConfig?.imagePlaceholder ||
                  process.env.NEXT_PUBLIC_IMAGE_PLACEHOLDER ||
                  ''
            }
            quality={100}
            alt={productName}
            width={93}
            height={93}
          />
        </div>
        {product?.labels &&
          product?.labels?.map((item, index) => {
            return (
              <span
                className={`${labelPositionProductCard.get(
                  item?.position
                )} label hiddenScrollBar absolute`}
                key={index}
                style={{ zIndex: 20 + index }}
              >
                <ImageOptimize
                  src={item?.image}
                  alt={getTranslate(item?.name)}
                  width={200}
                  height={48}
                  className='h-auto w-auto'
                />
              </span>
            )
          })}
      </div>
      <div className={`flex w-full flex-col flex-wrap bg-white-400 text-left `}>
        {product.label && (
          <span className='mb-1 rounded border bg-info-background bg-opacity-10 px-[4px] py-[2px] text-mainBody uppercase text-info-text opacity-90'>
            {product?.label}
          </span>
        )}
        <div className='mb-[5px] line-clamp-2 block h-[40px] overflow-hidden text-ellipsis font-mulish text-mainBody capitalize leading-5 text-dark-400 focus:border-0 focus:outline-0'>
          {productName}
        </div>
        <div className={`${type ? type : ''} price-wrapper w-full mt-1`}>
          <SalePrice finalPrice={product.finalPrice} type={type} />
          <div className='sale-price flex mt-[2px]'>
            <div className='flex items-center gap-x-1 text-mainBody'>
              <OriginPrice
                originPrice={product?.price}
                type={type}
                classes={'!m-0'}
              />
              {percent > 0 && (
                <span className='flex items-baseline gap-[2px]'>
                  <span className='flex items-baseline text-SmallCenter bg-red-500 text-white rounded-[2px] p-[2px]'>
                    <span className='value'>-{percent}</span>
                    <span className='unit text-SmallCenter'>%</span>
                  </span>
                </span>
              )}
            </div>
          </div>
        </div>
        {canCompare && (
          <button
            onClick={handleAddToCompare}
            className='mx-auto mt-[15px] flex items-center'
          >
            <span className='text-blue flex items-center'>
              <CompareIcon className='mr-[2px] inline-block' /> So sánh
            </span>
          </button>
        )}
      </div>
    </div>
  )
}

export default ProductCompareCard
